export default __webpack_public_path__ + "static/media/Create-Profile-Graphic.9c2a2149.jpg";